//ApplicationProgress.tsx
import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Typography from '@mui/material/Typography';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import PauseCircleOutlineIcon from '@mui/icons-material/PauseCircleOutline';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import theme from '../../../../style/theme';
import { ProgressInquiryType } from './ProgressInquiryType';
import { CloseRounded, ErrorOutlineRounded } from '@mui/icons-material';
import dayjs from "dayjs";

/**
 * 申請進捗ステッパーコンポーネント
 * - 申請の各アクティビティをステップ形式で表示し、ステータスに応じたアイコンを表示する
 * - props: data (申請進捗データ)
 */
export default function ApplicationProgress({ data }: { data: ProgressInquiryType  }) {

  const { applicantName, applicationNumber, submittedAt, applicationType, applicationName, activities } = data;

  const steps = [...activities]
    .sort((a, b) => a.order - b.order) // orderの昇順でソート
    .map((act) => ({
      id: act.id,
      name: act.activityName,
      status: act.status || 'NotStarted', // デフォルトは "未開始"
      endAt: act.endAt,
    }));

   // 進行中のステップ
   const activeStep = steps.findIndex((step) => step.status === 'InProgress');

   // StepIconコンポーネントの定義
  const StepIcon = (props: { stepIndex: number, stepStatus: string }) => {
    const { stepStatus } = props;
    if (stepStatus === 'InProgress') {
      return <AutorenewIcon sx={{ color: theme.palette.primary.main,fontSize:'0.9rem', }} />;
    } else if (stepStatus === 'Completed') {
       return<TaskAltRoundedIcon color='success' sx={{ fontSize:'0.9rem'}} />; //#66BB6A
    } else if (stepStatus === 'Failed') {
      return <CloseRounded color="error" sx={{ fontSize:'0.9rem'}} />;
    } else if (stepStatus === 'Error') {
      return <ErrorOutlineRounded color="warning" sx={{ fontSize:'0.9rem'}} />;
    } else {
      return <PauseCircleOutlineIcon sx={{ color: theme.palette.secondary.dark,fontSize:'0.9rem' }} />;
    }
  };

  return (

    <Box sx={{display:'flex',flexDirection:'column',gap:1,maxWidth: '100%' }}>
      {/*申請番号・申請日ラベル*/}
      <Box sx={{display:'flex',mb:0.5}}>
      <Chip  color="primary" label={`申請番号: ${data.applicationNumber}`}
             sx={{maxHeight:'20px', mr:1, }} size='small' />
       <Chip size="small" variant="outlined" color="success" label={`申請日：${dayjs(submittedAt).isValid() ? dayjs(submittedAt).format("YYYY/MM/DD") : "未提出"}`}
           sx={{maxHeight:'20px', }} />
      </Box> 
      {/*申請種類・申請書名*/}
      <Box sx={{display:'flex',flexDirection:'column'}}>
      <Box sx={{display:'flex',}}>
      <Typography variant="h3" sx={{ mx:1,}}>
             {data.applicationType}
      </Typography>
      </Box>
      <Box sx={{display:'flex'}}>
      <Tooltip title={data.applicationName} arrow>
      <Typography variant="h3"  color="textSecondary" 
      sx={{
        mx:1,
      }}>
      {data.applicationName} 
      </Typography> 
      </Tooltip>
      </Box>
      <Tooltip title={data.description} arrow>
      <Typography variant="body1"  color="textSecondary" 
      sx={{
        mx:1,
      }}>
             {data.description}
      </Typography>
      </Tooltip>
      </Box>
      {/* Stepper*/}
      <Box sx={{}}>
      <Stepper activeStep={activeStep} orientation="vertical"
      sx={{
        mt:-1,
        '& .MuiStepConnector-line': {
           position:'relative',
           minHeight:'10px',
           borderLeftWidth: 1, 
           ml:0.4
         },
      }}>
        {steps.map((step, index) => (
          <Step key={step.id}
          sx={{
            ml:1,
          }}>
             {/* Stepperの数字の代わりに定義したStepIconを表示 */}
                {/* ステップ内容：アクティビティ状態 */}
             <StepLabel
              StepIconComponent={() => <StepIcon stepIndex={index} stepStatus={step.status} />}
            >
              <Typography variant='body1'
                sx={index === activeStep ? { color: '#666666' } : {}}
                fontWeight={index === activeStep ? 'bold' : ''}>
                {step.name}{(step.endAt && step.status === 'Completed') && (dayjs(step.endAt).format("YYYY/MM/DD HH:mm"))}
              </Typography>
            </StepLabel>
            <StepContent>
            </StepContent>
          </Step>
        ))}
      </Stepper>
      </Box>
    </Box>
  );
}
  